import { gql } from '@apollo/client'

export const DELETE_OFFER = gql`
  mutation deleteOffer($input: ID!) {
    data: deleteOffer(id: $input) {
      id
    }
  }
`
